import React, { Fragment } from "react";
import externalLink from "../../../assets/images/external-link.png";

const PatterMasterReportList = props => {
    let stylePage = listValue => {
        {
            let action =
                (props.styleRights.web.edit && "edit") ||
                (props.rights.web.view && "view");
            let newSearch = "?" + new URLSearchParams({
                action: action,
                _id: listValue._id,
                hash: `seleted${listValue.code.split("-").join("")}`
            }).toString()
            // window.open(`/StylePage${newSearch}`, "_blank")     
            window.open(`/StylePage${newSearch}#seleted${listValue.code.split("-").join("")}`, "_blank")
        };

    };
    let samplePage = data => {
        let action = (props.sampleRights.sampleRequest.web.edit && "edit") || (props.sampleRights.sampleRequest.web.view && "view");
        let search = "?" + new URLSearchParams({
            action: action,
            _id: data._id
        }).toString()
        window.open(`/Sample${search}`, "_blank")
    }
    return (
        <Fragment>
            <tr>
                {props.list !== undefined &&
                    Array.isArray(props.list) &&
                    props.list.length > 0 &&
                    Object.keys(props.list[0]).map(listValue => {
                        return (
                            <td className="report-header text-center border">{listValue}</td>
                        );
                    })}
            </tr>
            {props.list !== undefined &&
                Array.isArray(props.list) &&
                props.list.length > 0 &&
                props.list.map(listValue => {
                    return (
                        <Fragment>
                            <tr>
                                {Object.keys(listValue).map(listData => {

                                    return listData === "SAMPLE REQUEST NO" ? (
                                        <td className="d-flex align-items-center justify-content-between">
                                            {listValue[listData].number}
                                            <img
                                                title={`Go To Sample Page Of ${listValue[listData].number}`}
                                                className={"cursor-hover"}
                                                style={{
                                                    cursor: "pointer",
                                                    marginTop: "-1px",
                                                    verticalAlign: "top",
                                                    marginLeft: "5px"
                                                }}
                                                onClick={() => samplePage(listValue[listData])}
                                                src={externalLink}
                                            />
                                        </td>
                                    ) : listData === "STYLE NO" ? (
                                        <td>
                                            {listValue[listData].code}
                                            <img
                                                title={`Go To Style Page Of ${listValue[listData].code}`}
                                                className={"cursor-hover"}
                                                style={{
                                                    cursor: "pointer",
                                                    marginTop: "-1px",
                                                    verticalAlign: "top",
                                                    marginLeft: "5px"
                                                }}
                                                onClick={() => stylePage(listValue[listData])}
                                                src={externalLink}
                                            />
                                        </td>
                                    ) : (
                                        <td
                                            className={
                                                listData.trim() === "STYLE NAME" || listData.trim() === "CUST-DEPT" || listData.trim() === "SAMPLE TYPE"
                                                ? "text-left"
                                                : ""
                                            }
                                            >
                                            {listValue[listData]}
                                            </td>
                                        );
                                })}
                            </tr>
                        </Fragment>
                    );
                })}
            {/* {props.list !== undefined &&
        Array.isArray(props.list) &&
        props.list.length > 0 &&
        props.list.map(listValue => {
          return (
           
          );
        })} */}
        </Fragment>
    );
};

export default PatterMasterReportList;


// WEBPACK FOOTER //
// ./src/components/Report/reports/patternMaster.js